import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { reconciliationService } from '../../../api/reconciliation';
import { PaginatedRequest } from '../../../types/api';
import { ReconciliationRunExportData } from '../../../types/reconciliation';

export const clearReconciliationRunItemDetail = createAction('reconciliation/clear-run-item-detail');

export const fetchReconciliationRuns = createAsyncThunk(
  'reconciliation/fetch-reconciliation-runs',
  (data: PaginatedRequest & { orderId: string }) => reconciliationService.fetchReconciliationRuns(data),
);

export const fetchReconciliationRunDetail = createAsyncThunk('reconciliation/fetch-run-detail', (runId: number) =>
  reconciliationService.fetchReconciliationRunDetail(runId),
);

export const fetchReconciliationRunItemDetail = createAsyncThunk(
  'reconciliation/fetch-run-item-detail',
  ({ runId, itemId }: { runId: number; itemId: number }) =>
    reconciliationService.fetchReconciliationRunItemDetail(runId, itemId),
);

export const clearReconciliationRunDetail = createAction('reconciliation/clear-run-detail');

/** Fetches full export JSON (all items + metric comparisons); UI builds CSV / XLSX. */
export const fetchReconciliationRunExportJson = createAsyncThunk<
  ReconciliationRunExportData,
  number,
  { rejectValue: { message: string } }
>('reconciliation/fetch-run-export-json', async (runId, { rejectWithValue }) => {
  const res = await reconciliationService.fetchReconciliationRunExport(runId);
  if (res.status !== 'success') {
    return rejectWithValue({ message: res.message || 'Export failed' });
  }
  if (!res.data?.run || !Array.isArray(res.data.items)) {
    return rejectWithValue({ message: 'Invalid export response' });
  }
  return res.data;
});
